<template>
    <div class="wide-banner">
        <p class="banner-line">
            <span class="line-item">Fastest Search in North America</span>
            <span class="divider"></span>
            <span class="line-item">Most Accurate Service Information</span>
        </p>
        <p class="banner-line">
            <span class="line-item">Heavy duty service verified</span>
            <span class="divider"></span>
            <span class="line-item">No Duplicate Listings</span>
        </p>
    </div>
</template>

<script>import script from './PropsBanner';
    export default script;</script>

<style lang="less" scoped>
    @import "./PropsBanner.less";
</style>

